import { SECTION_HOMEPAGE, SECTION_CATEGORY } from '../constants/sections';
import { POST_TITLE_COLOR, POST_TITLE_FONT, POST_TEXT_COLOR, POST_PAGE_FONT, BUTTON_COLOR, BUTTON_TEXT_COLOR, } from '../constants/wix-params';
import { getSiteColor } from './colors';
import { getSiteFont } from './fonts';
const wixParamMap = {
    [SECTION_HOMEPAGE]: {
        titleColor: 'post-homepage-titleColor',
        titleFont: 'post-full-homepage-titleFont',
        textColor: 'post-homepage-descriptionColor',
        textFont: 'post-full-homepage-descriptionFont',
    },
    [SECTION_CATEGORY]: {
        titleColor: 'post-category-titleColor',
        titleFont: 'post-full-category-titleFont',
        textColor: 'post-category-descriptionColor',
        textFont: 'post-full-category-descriptionFont',
    },
};
export const getBannerTheme = ({ appSettings, section, }) => {
    const wixParams = wixParamMap[section] ?? {
        titleColor: POST_TITLE_COLOR,
        titleFont: POST_TITLE_FONT,
        textColor: POST_TEXT_COLOR,
        textFont: POST_PAGE_FONT,
    };
    const titleColor = getSiteColor(appSettings, {
        wixParam: wixParams.titleColor,
        presetFallback: 'color-5',
        colorFallback: '#2f2e2e',
        hex: true,
    });
    const titleFont = getSiteFont(appSettings, {
        wixParam: wixParams.titleFont,
        presetFallback: 'Body-M',
        fontFallback: "'open sans',sans-serif",
        onlyFamily: true,
    });
    const textColor = getSiteColor(appSettings, {
        wixParam: wixParams.textColor,
        presetFallback: 'color-5',
        colorFallback: '#000',
        hex: true,
    });
    const textFont = getSiteFont(appSettings, {
        wixParam: wixParams.textFont,
        presetFallback: 'Body-M',
        fontFallback: "'open sans',sans-serif",
        onlyFamily: true,
    });
    const buttonColor = getSiteColor(appSettings, {
        wixParam: BUTTON_COLOR,
        presetFallback: 'color-8',
        colorFallback: '#3899ec',
        hex: true,
    });
    const buttonTextColor = getSiteColor(appSettings, {
        wixParam: BUTTON_TEXT_COLOR,
        presetFallback: 'color-1',
        colorFallback: '#fff',
        hex: true,
    });
    return {
        palette: {
            actionColor: buttonColor,
            bgColor: buttonTextColor,
        },
        customStyles: {
            h3: {
                color: titleColor,
                fontFamily: titleFont,
            },
            p: {
                color: textColor,
                fontFamily: textFont,
            },
        },
    };
};
//# sourceMappingURL=paywall-theme.js.map